import { render } from "./Files.vue?vue&type=template&id=5a7d5024&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import "./Files.vue?vue&type=style&index=0&id=5a7d5024&scoped=true&lang=css"
import "./Files.vue?vue&type=style&index=1&id=5a7d5024&scoped=true&lang=css"
import "./Files.vue?vue&type=style&index=2&id=5a7d5024&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7d5024"]])

export default __exports__